import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

type StatsCardProps = {
  icon: LucideIcon;
  label: string;
  value: ReactNode;
  subtitle?: ReactNode;
  trend?: {
    value: number;
    label: string;
    positive?: boolean;
  };
  className?: string;
};

export function StatsCard({
  icon: Icon,
  label,
  value,
  subtitle,
  trend,
  className,
}: StatsCardProps) {
  return (
    <Card className={cn("h-full", className)}>
      <CardContent className="pt-6">
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <p className="text-sm font-medium text-muted-foreground">{label}</p>
            <div className="text-3xl font-bold tracking-tight">{value}</div>
            {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
            {trend && (
              <p
                className={cn(
                  "text-sm font-medium",
                  trend.positive ? "text-[hsl(var(--brand))]" : "text-muted-foreground",
                )}
              >
                {trend.positive && "+"}
                {trend.value} {trend.label}
              </p>
            )}
          </div>
          <div className="rounded-lg bg-primary/10 p-3">
            <Icon className="h-5 w-5 text-primary" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
